import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { DlsIconModule } from '@zelis/dls/icons';
// TODO per: https://github.com/mdx-dev/sapphire/pull/217/files#r728842348
import { MatButtonModule } from '@angular/material/button';
import { DlsClampModule } from '@zelis/dls/clamp';

@NgModule({
  imports: [CommonModule, DlsIconModule, MatButtonModule, DlsClampModule],
  declarations: [BannerComponent],
  exports: [BannerComponent],
})
export class DlsBannerModule {}
